import { render } from "./NotFound.vue?vue&type=template&id=6e3be494"
const script = {}
script.render = render

export default script